export default __webpack_public_path__ + "static/media/new-seat-icon.eb2eab65.svg";